import NewsListTitle from "./NewsListTitle.vue";
import NewsListItem from "./NewsListItem.vue";
export default {
    props: {
        items: {
            type: (Array),
            default: [],
        }
    },
    components: {
        NewsListTitle,
        NewsListItem
    }
};
